import { api, tokens } from '../app/api.js';
import { queryClient } from '../app/query.js';

/** Ends the session on the server (best effort) and forgets it here. */
export async function signOut(): Promise<void> {
  if (tokens.get()) {
    try {
      await api.client.POST('/v1/auth/logout');
    } catch {
      // Offline or already ended: the tokens are dropped below either way.
    }
  }
  tokens.set(null);
  queryClient.clear();
}
